import { render, staticRenderFns } from "./AgentCommissionList.vue?vue&type=template&id=c495e70e&scoped=true"
import script from "./AgentCommissionList.vue?vue&type=script&lang=js"
export * from "./AgentCommissionList.vue?vue&type=script&lang=js"
import style0 from "./AgentCommissionList.vue?vue&type=style&index=0&id=c495e70e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c495e70e",
  null
  
)

export default component.exports